/** Keep the selected Help journey across languages without carrying tracking data. */
export function helpNavigationSearch(pathname: string, search: string): string {
  if (!/^\/(?:hjalp|en\/help)(?:\/|$)/.test(pathname)) return "";
  const source = new URLSearchParams(search);
  const context = new URLSearchParams();
  for (const key of ["section", "stage"]) {
    const value = source.get(key);
    if (value) context.set(key, value);
  }
  const query = context.toString();
  return query ? `?${query}` : "";
}
